import { bookService, taskService } from '@/services'

import { firstTeamBook, thirdTeamBook, headquartersProjects } from '@/onboarding'

export default async ({ commit, settings, headquartersId, dispatch, onboardingData }) => {
  try {
    // CREATE FIRST SECTION
    await bookService.createSection('Teams')

    // CREATE FIRST BOOK
    await firstTeamBook({ commit, settings, dispatch })

    // CREATE SECOND SECTION
    await bookService.createSection('Projects')

    // CREATE THIRD BOOK
    await thirdTeamBook(commit, settings)

    // CREATE HEADQUARTERS FIRST PROJECT
    await headquartersProjects(headquartersId, settings)

    if (onboardingData && onboardingData?.bookTitle?.trim() !== '') {
      const book = await bookService.create({
        title: onboardingData.bookTitle.trim(),
        subTitle: 'This is a space, let\'s add some pages to it.',
        icon: 'default-waves'
      })

      if (onboardingData.taskName?.trim() !== '') {
        const rows = await taskService.getRows({ bookId: book.data.dataValues.id })
        if (rows?.data?.taskRows?.length === 0) return

        await dispatch('createTask', {
          title: onboardingData.taskName.trim(),
          subTitle: '',
          additionalInfo: '',
          isUrgent: false,
          position: '0',
          taskRowId: rows.data.taskRows[0].id,
          bookId: book.data.dataValues.id
        })
      }
    }

    return Promise.resolve()
  } catch (err) {
    commit('loading', false)
    return Promise.reject(err)
  }
}
